import { createClient } from '@supabase/supabase-js';
import type { SupabaseClient, CreateSupabaseClientOptions } from './types';
import { LOCAL_SUPABASE_URL, LOCAL_SUPABASE_ANON_KEY, DEFAULT_SUPABASE_CONFIG } from './config';

/**
 * Factory function to create Supabase client with consistent configuration
 */
export function createSupabaseClient(
  options: CreateSupabaseClientOptions = {}
): SupabaseClient {
  const url = options.url || LOCAL_SUPABASE_URL;
  const anonKey = options.anonKey || LOCAL_SUPABASE_ANON_KEY;
  const config = { ...DEFAULT_SUPABASE_CONFIG, ...options.config };

  return createClient(url, anonKey, config);
}

/**
 * Set JWT token for Realtime authentication
 * Used by vendor-dashboard for supplier authentication
 */
export function setSupabaseAuth(
  client: SupabaseClient,
  accessToken: string
): void {
  client.realtime.setAuth(accessToken);
}

/**
 * Get Supabase client instance (backward compatibility helper)
 */
export function getSupabaseClient(client: SupabaseClient): SupabaseClient {
  return client;
}
